module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v(". . . the ghosts of our future")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("are unpredictable")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("and out of control.")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("—Wendy Rose,")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("from “The Fifties”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0